<template>
  <transition name="fade">
    <div class="tool-select" v-show="showTool">
      <div class="tool-box">
        <h5 class="tool-title"><i class="iconfont">&#xe65b;</i><i class="title">{{titleText}}</i></h5>
        <p class="tool-content">{{text}}</p>
        <div class="btn-wrap">
          <div class="btn btn-cancel" @click.stop = "cancel"><span>{{btnCancel}}</span></div>
          <div class="btn btn-sure" @click.stop = "sure"><span>{{btnSure}}</span></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
  export default{
    props: {
      titleText: {
        type: String,
        default: '提示'
      },
      btnCancel: {
        type: String,
        default: '否'
      },
      btnSure: {
        type: String,
        default: '是'
      },
      text: {
        type: String,
        default: '是否确定执行此操作?'
      }
    },
    data() {
      return {
        showTool: false
      };
    },
    methods: {
      sure() {
        this.$emit('sure');
        this.showTool = false;
      },
      cancel() {
        this.$emit('cancel');
        this.showTool = false;
      },
      show() {
        this.showTool = true;
      },
      hide() {
        this.showTool = false;
      }
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  .tool-select
    display:flex
    justify-content:center
    align-items:center
    position:fixed
    z-index:1000
    top:0
    bottom:0
    left:0
    right:0
    width:100%
    background-color:rgba(7, 17, 27, 0.6)
    &.fade-enter-active,&.fade-leave-active
      transition:all 0.2s
    &.fade-enter,&.fade-leave-active
      opacity:0
    .tool-box
      width:80%
      background-color:#fff
      .tool-title
        margin:0
        padding:10px
        font-size:16px
        font-weight:200
        color:#d91d36
        border-bottom:1px solid #d91d36
        .iconfont
          vertical-align:top
          margin-right:8px
        .title
          vertical-align:top
      .tool-content
        margin:0
        padding:6px 15px
        width:100%
        font-size:16px
        line-height:24px
        color:#333
        word-break:break-all
        max-height:200px
        overflow-y:auto
      .btn-wrap
        display:flex
        width:100%
        border-top:1px solid #efefef;
        .btn
          padding:15px 0px
          width:50%
          text-align:center
          font-size:16px
          color:#333
        .btn-cancel
          border-right:1px solid #efefef
</style>



// WEBPACK FOOTER //
// toolselect.vue?30fadd72